<template>
  <div>
    <v-btn 
      @click="kakaoSignup()" 
      color="#FEE500"
      block
      :x-large="$vuetify.breakpoint.smAndUp ? true :false"
      elevation="0"
      v-show="isUsed">
        <v-icon left>$vuetify.icons.fld_kakao</v-icon>
      {{ $t('signup.btn.kakao_signup') }}
    
    </v-btn>
  </div>
</template>



<script>
import { javascriptKey } from "@/redcrm/api/kakaoApi.js";
import {$getSignupConfig} from "@/redcrm/api/configs.js";
export default {
  data(){
    return{
      isUsed:false
    }
  },
  methods: {
    async getSignupConfig(){
      try {
        const { data } = await $getSignupConfig();
        const signup = JSON.parse(data.result.configVal);
        this.isUsed = signup.kakaoSync.isUsed
      } catch {
        this.$rxSnackbar("error", this.$t("common.msg.unexpected_error"));
      }
    },
    async kakaoSignup() {
      //간편 로그인
      const jsKey = await javascriptKey;
      window.Kakao.init(jsKey.data);
      var host = window.location.host;
      var pro = window.location.protocol;

      const param = {
        redirectUri: pro + "//" + host + "/signup",
        // scope: "account_email,gender,birthday,birthyear,name,phone_number",
        serviceTerms: "marketing_terms,join_terms,point_terms",
      };
      window.Kakao.Auth.authorize(param);
    },
  },
  created(){
    this.getSignupConfig();
  }
};
</script>

<style></style>
